// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"53b1fc5f","477":"9ef54957","780":"dc4b1ad6","858":"7c900194"}[chunkId] + ".chunk.js";
};